export default __webpack_public_path__ + "media/images/preview-5b6ad90be61f8871cd0b6a17af7d8f74.png";